import { Grid, Typography } from "@mui/material";
import {
  IOtherInformationSetupFieldsPanel,
  OtherInformationSetupFieldsPanel,
} from "./OtherInformationSetupFieldsPanel";

import { FC } from "react";
import { TaxSlipDataInput } from "../../TaxSlipDataInput";

export interface IT4ASlipDataPanel extends IOtherInformationSetupFieldsPanel { }

export const T4ASlipDataPanel: FC<IT4ASlipDataPanel> = ({
  formMethods,
  otherInformationList,
  isLoading,
  testId,
  selectedOtherInformation,
  oiInEdit,
  taxYear,
  selectedProvinceLabel
}) => {
  return (
    <>
      <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 6 }}></Grid>
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}></Grid>
        <Grid
          size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
          sx={{ textAlign: "center", fontWeight: "bold" }}
        >
          <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
            Actual
          </Typography>
        </Grid>
      </Grid>
      <TaxSlipDataInput
        id="pensionOrSuperannuation"
        label="Pension Or Superannuation"
        boxNumber="016"
      />
      <TaxSlipDataInput
        id="lumpSumPayments"
        label="Lump-Sum Payments"
        boxNumber="018"
        // alert={true}
        alertTitle='Sum of other info boxes: 102, 108, 110, 180, 190'
        titlePlacement='top'
      />
      {taxYear < 2025 && <TaxSlipDataInput
        id="lumpSumPaymentsOther"
        label="Lump-Sum Payments (Other)"
        boxNumber="18"
        // alert={true}
        alertTitle='Other applicable amounts'
      />}
      <TaxSlipDataInput
        id="selfEmployedCommissions"
        label="Self-Employed Commissions"
        boxNumber="020"
      />
      <TaxSlipDataInput
        id="incomeTaxDeducted"
        label="Income Tax Deducted"
        boxNumber="022"
      />
      <TaxSlipDataInput
        id="annuities"
        label="Annuities"
        boxNumber="024"
        // alert={true}
        alertTitle='Sum of other information boxes: 111, 115'
      />
      {taxYear < 2025 && <TaxSlipDataInput
        id="annuitiesOther"
        label="Annuities (Other)"
        boxNumber="026"
      />}
      <TaxSlipDataInput id="fees" label="Fees" boxNumber="048" />
      {selectedProvinceLabel && selectedProvinceLabel === "Saskatchewan" &&
        <TaxSlipDataInput id="saskatchewanPensionPlanSpousalContributorIndicator" label="Saskatchewan Pension Plan spousal contributor indicator" boxNumber="" showBoxNumber={false} yesNoField={true} />}
      {selectedProvinceLabel && selectedProvinceLabel === "Saskatchewan" &&
        <TaxSlipDataInput id="saskatchewanPensionPlanSpousalContributorSin" label="Saskatchewan Pension Plan spousal contributor SIN" boxNumber="" showBoxNumber={false} sinField={true} />}
      <Grid
        container
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        sx={{ mt: 2, p: 4, backgroundColor: "#f4f5f7" }}
      >
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: "bold", pb: 1 }}>
            Other Information
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          <OtherInformationSetupFieldsPanel
            formMethods={formMethods}
            isLoading={isLoading}
            otherInformationList={otherInformationList}
            testId={testId}
            selectedOtherInformation={selectedOtherInformation}
            oiInEdit={oiInEdit}
            taxYear={taxYear}
            selectedProvinceLabel={selectedProvinceLabel}
          />
        </Grid>
      </Grid>
    </>
  );
};
